<template>
	<el-dialog title="选择Lark URL站点" :visible.sync="dialogVisible" width="400px" @close="reset">
		<span>Lark URL：</span>
		<el-select v-model="value" size="small" placeholder="请选择"  :disabled="!['', null, undefined].includes(larkUrl)" style="width：300px;">
			<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
		</el-select>
		<p style="padding-left: 74px">提示：Lark Url一旦提交后，将无法更改</p>
		<span slot="footer" class="dialog-footer" v-show="['', null, undefined].includes(larkUrl)">
			<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
			<el-button type="primary" @click="commit" size="mini">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
	name: "larkUrlManage",
	data() {
		return {
			dialogVisible: false,
			options: [],
			value: "",
			brandIdentify: '',
			larkUrl: '',
			brandId: ''
		}
	},
	computed: {
		...mapGetters([
			"userInfo"
		])
	},
	methods: {
		open(row) {
			this.brandIdentify = row.brandIdentify;
			this.larkUrl = row.larkUrl;
			this.brandId = row.brandId;
			this.value = this.larkUrl ? this.larkUrl : '';
			this.dialogVisible = true;
			this.requestLarkUrlOptions();
		},
		requestLarkUrlOptions() {
			this.$api.projectSwitchList({})
				.then(res => {
					console.log(res);
					if (res.errcode != 0) return false;
					this.options = res.data;
				})
		},
		commit() {
			this.$api.projectSwitchEditBrandLarkSwtich({
				brandIdentify: this.brandIdentify,
				larkSwitchId: this.value
			}).then(res => {
				if (res.errcode != 0) return false;
				this.$api.apiPostAuthBrandManageField({brandId: this.brandId, larkUrl: this.value}).then(response => {
					if (response.errcode != 0) return false;
					this.$message({
						type: 'success',
						message: '修改成功!'
					});
					this.dialogVisible = false;
					this.$emit('onEmitUpload');
				})
			})
		},
		reset(){
			Object.assign(this.$data, this.$options.data.call(this));
		}
	}
}
</script>
<style scoped>
</style>